import { gql } from "@apollo/client";

export const USER = gql`
  query Users($where: UserWhereInput!) {
    users(where: $where) {
      id
      firstName
      lastName
      email
      username
      phone
      userRole {
        id
        role
      }
      organizations {
        id
        name
        email
        organizationType {
          id
          name
        }
        address {
          id
          street1
          street2
          city
          state
          zipcode
          country
        }
      }
    }
  }
`;

export const ASN = gql`
  query GetASN($where: GetASNWhereInput!) {
    getASN(where: $where) {
      domain
      topic {
        id
        statementLabel
        statementNotation
        description
      }
      subTopic {
        id
        statementLabel
        statementNotation
        description
      }
    }
  }
`;

export const USER_GRADES_SUBJECTS = gql`
  query UserGradesAndSubjects {
    getDynosPlusUserGradesAndSubjects {
      grades {
        id
        dynoGradeId
        name
      }
      subjects {
        id
        dynoSubjectId
        name
      }
    }
  }
`;
export const USER_DYNOES = gql`
  query UserDynos($where: DynosPlusUserDynosWhereInput!) {
    getDynosPlusUserDynos(where: $where) {
      id
      name
      domains {
        id
        name
        topics {
          id
          name
          subTopics {
            id
            name
            dynoes {
              id
              dynoTitle
              status {
                id
                statusType
              }
            }
          }
        }
      }
    }
  }
`;
export const INDPARENT = gql`
  query IndParent($where: IndParentWhereInput) {
    indParents(where: $where) {
      id
      pupil {
        id
        firstName
        lastName
        username
      }
    }
  }
`;
export const STUDENTS = gql`
  query Students($where: GetPlusOrgSubscribersWhereInput!) {
    getPlusOrgSubscribers(where: $where) {
      id
      firstName
      lastName
      username
    }
  }
`;
export const DYNOSTATUSES = gql`
  query DynoStatuses($where: DynoStatusWhereInput) {
    dynoStatuses(where: $where) {
      id
      statusType
    }
  }
`;
export const ORG_GRADES_SUBJECTS = gql`
  query OrganizationGrades(
    $gradeWhere: OrganizationGradeWhereInput
    $subjectWhere: OrganizationSubjectWhereInput
  ) {
    organizationGrades(where: $gradeWhere) {
      id
      gradeName
    }
    organizationSubjects(where: $subjectWhere) {
      id
      subjectName
    }
  }
`;
export const ORG_CLASSES = gql`
  query OrgClasses($where: OrganizationClassWhereInput) {
    organizationClasses(where: $where) {
      id
      name
      modules {
        id
        moduleName
      }
    }
  }
`;
export const MY_CLASSES = gql`
  query OrganizationClasses($where: OrganizationClassWhereInput) {
    organizationClasses(where: $where) {
      id
      name
      isActive
      grade {
        gradeName
      }
      subject {
        subjectName
      }
      primaryCreator {
        firstName
        lastName
      }
    }
  }
`;
export const MY_DYNOES = gql`
  query Dynoes($where: DynoWhereInput) {
    dynoes(where: $where) {
      id
      dynoTitle
    }
  }
`;
export const CLASS_MODULES = gql`
  query GetPracticeModules($where: GetPracticeModulesWhereInput!) {
    getPracticeModules(where: $where)
  }
`;
export const SUBMISSIONS = gql`
  query Submissions($where: SubmissionWhereInput) {
    submissions(where: $where, orderBy: { submittedAt: desc }) {
      id
      submittedAt
      comment
      totalPoints
      isManual
      dyno {
        id
      }
      organizationClass {
        id
      }
      submitter {
        id
        email
        phone
        firstName
        lastName
        avatarColor
      }
      reviewedAt
      quizAnswers {
        id
        name
        value
        teacherComment
        points
        variable {
          id
          fieldName
          title
          defaultValue
          variableAttributes
          variableType {
            variableType
          }
          possibleAnswers {
            id
            value
            maxPoints
          }
        }
      }
    }
  }
`;
export const CLASS_TEACHER_SUBSCRIBERS = gql`
  query OrganizationClass($where: OrganizationClassWhereUniqueInput!) {
    organizationClass(where: $where) {
      creator {
        id
        firstName
        lastName
        email
      }
      subscribers {
        id
        firstName
        lastName
        username
      }
    }
  }
`;
export const SEARCHBYSCHOOL = gql`
  query SearchBySchool($name: String!, $limit: Int) {
    searchBySchool(name: $name, limit: $limit) {
      id
      schoolName
      schoolType
      street1
      street2
      city
      stateName
      zip
      country
      organizationType
    }
  }
`;
export const ORGANIZATION_TYPES = gql`
  query GetAllTheThings {
    organizationTypes {
      id
      name
    }
  }
`;
